export default "__VITE_ASSET__D3IJf4R9__"